@if (canAccessRequests) {
<div class="lm-leave-container">
  <lm-loading-overlay [show]="isProcessing" message="Processing..."></lm-loading-overlay>
  <div class="lm-sub-tabs">
    <button
      class="lm-sub-tab-btn"
      [class.active]="activeTab === 'leave'"
      (click)="setActiveTab('leave')">
      Leave Requests
      @if (showPendingBadges && pendingLeaveCount > 0) {
      <span class="lm-pending-badge">{{ pendingLeaveCount }}</span>
      }
    </button>
    <button
      class="lm-sub-tab-btn"
      [class.active]="activeTab === 'hourly'"
      (click)="setActiveTab('hourly')">
      Hourly Permission
      @if (showPendingBadges && pendingHourlyCount > 0) {
      <span class="lm-pending-badge">{{ pendingHourlyCount }}</span>
      }
    </button>
    @if (effectiveIsManager) {
    <button
      class="lm-sub-tab-btn"
      [class.active]="activeTab === 'scheduledLeaves'"
      (click)="setActiveTab('scheduledLeaves')">
      {{ 'leave_management.employee_leave_request.scheduled_leaves' | transloco }}
    </button>
    }
    @if (effectiveIsManager) {
    <button
      class="lm-sub-tab-btn"
      [class.active]="activeTab === 'scheduledHourly'"
      (click)="setActiveTab('scheduledHourly')">
      {{ 'leave_management.employee_leave_request.scheduled_hourly_permission' | transloco }}
    </button>
    }
    @if (canViewLeaveBalanceTab()) {
    <button
      class="lm-sub-tab-btn"
      [class.active]="activeTab === 'leaveBalance'"
      (click)="openLeaveBalanceTab()">
      {{ 'leave_management.employee_leave_request.leave_balance' | transloco }}
    </button>
    }

    <!-- HR/Manager view toggle -->
    @if (showViewToggle) {
    <div class="lm-view-toggle">
      <span class="lm-view-toggle-label" [class.active]="viewMode === 'hr'">{{ 'leave_management.employee_leave_request.all_employees' | transloco }}</span>
      <button class="lm-toggle-switch" [class.manager]="viewMode === 'manager'" (click)="toggleViewMode()" type="button">
        <span class="lm-toggle-knob"></span>
      </button>
      <span class="lm-view-toggle-label" [class.active]="viewMode === 'manager'">{{ 'leave_management.employee_leave_request.my_team' | transloco }}</span>
    </div>
    }
  </div>

  @if (activeTab === 'leave') {
  <div class="lm-grid-card">
    <div class="lm-grid-body">
      <ers-grid
        [columnDefs]="columnDefs"
        [rowData]="rowData"
        [gridOptions]="customGridOptions"
        (cellClicked)="onAllGridCellClick($event)"
      ></ers-grid>
    </div>
    <div class="lm-grid-footer">
      <ers-month-year-picker mode="compact" [currentMonth]="currentMonth" [currentYear]="currentYear" (dateChange)="onPickerChange($event)"></ers-month-year-picker>
      <div class="lm-footer-count">
        <span class="count">{{ totalRequests }}</span>
        <span class="count-label">{{ 'leave_management.employee_leave_request.total_requests' | transloco }}</span>
      </div>
    </div>
  </div>
  }

  @if (activeTab === 'hourly') {
  <div class="lm-grid-card">
    <div class="lm-grid-body">
      <ers-grid
        [columnDefs]="hourlyColumnDefs"
        [rowData]="hourlyRowData"
        [gridOptions]="customGridOptions"
        (cellClicked)="onHourlyGridCellClick($event)"
      ></ers-grid>
    </div>
    <div class="lm-grid-footer">
      <ers-month-year-picker mode="compact" [currentMonth]="currentMonth" [currentYear]="currentYear" (dateChange)="onPickerChange($event)"></ers-month-year-picker>
      <div class="lm-footer-count">
        <span class="count">{{ totalHourlyRequests }}</span>
        <span class="count-label">{{ 'leave_management.employee_leave_request.total_requests' | transloco }}</span>
      </div>
    </div>
  </div>
  }

  <!-- Scheduled Leaves tab (manager only) -->
  @if (activeTab === 'scheduledLeaves' && effectiveIsManager) {
  <div class="lm-scheduled-tab">
    <ers-manager-leave-panel
      [rowData]="managerPanelRowData"
      [isLoading]="isManagerPanelLoading"
    ></ers-manager-leave-panel>
  </div>
  }

  <!-- Scheduled Hourly Permission tab (manager only) -->
  @if (activeTab === 'scheduledHourly' && effectiveIsManager) {
  <div class="lm-scheduled-tab">
    <ers-manager-leave-panel
      [rowData]="managerHourlyPanelRowData"
      [isLoading]="isManagerPanelLoading"
      [onLeaveTitle]="'Employee on Hourly Permission'"
      [upcomingTitle]="'Upcoming Hourly Permissions'"
      [isHourlyMode]="true"
    ></ers-manager-leave-panel>
  </div>
  }

  @if (activeTab === 'leaveBalance' && canViewLeaveBalanceTab()) {
  <div class="lm-balance-tab">
    <ers-employee-leave-balance [isManagerView]="effectiveIsManager"></ers-employee-leave-balance>
  </div>
  }
</div>
}
